import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {StudentInfoResponse} from "../../types/student-info/studentInfoSchema";
import {setStudentData} from "../../slice/student-info/StudentInfoSlice";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


interface StudentInfoParams {
    groupId: string | undefined;
    studentId: string | undefined;
}

export const fetchStudentInfo = createAsyncThunk(
    "student/fetchStudentInfo",
    async ({ groupId, studentId }: StudentInfoParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<StudentInfoResponse>(
                `/api/groups/${groupId}/student-info/${studentId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setStudentData(response.data.data));


            }

            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
